module.exports = __webpack_public_path__ + "static/assets/cdd9647086ad951cddabef102e4e332b.gif";